export const getFieldLabel = key => {
  // "Primary Member ID" → "Primary Policy #", "Secondary Member ID" → "Secondary Policy #", etc.
  const memberIdReplaced = key.replace(/Member ID/gi, 'Policy #');
  if (memberIdReplaced !== key) return memberIdReplaced;

  const normalized = key.toLowerCase().replace(/[\s_.]/g, '');
  const labelMap = {
    payername: 'Payer Name',
    payerorder: 'Payer Order',
    policy: 'Policy #',
    policynumber: 'Policy #',
    memberid: 'Policy #',
    tripdate: 'Trip Date',
    coordinationtypeid: 'Payer Order',
    firstname: 'First Name',
    lastname: 'Last Name',
    dob: 'Date of Birth',
    address: 'Address',
    patientname: 'Patient Name',
    chiefcomplaint: 'Chief Complaint',
    triprequestchiefcomplaint: 'Chief Complaint',
    isbilledtofacility: 'Billed to Facility',
    triprequestisbilledtofacility: 'Billed to Facility',
  };
  return labelMap[normalized] || key;
};

export const objectToString = value => {
  if (value == null) return '';
  if (typeof value === 'object') {
    return Object.entries(value)
      .filter(([, val]) => val != null)
      .map(([key, val]) => `${key}: ${val}`)
      .join(', ');
  }
  return String(value);
};
